<div class="erp-modal" [hidden]="hidden">
  <div class="card info-dialog">
    <div class="card-body">
      <div class="text-right">
        <button type="button" class="close" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngFor="let content of errorContents">
        {{content}}
      </div>
    </div>
  </div>
</div>